import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import StatsRow from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/StatsRow'
import { isHourlyFixedBalanceAllowance } from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'
import type Allowance from 'modules/timeoff/store/models/Allowance'

import type {
  Cycle,
  ParsedAllowanceStat,
} from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/allowanceStatUtils'

import TakenTooltip from './TakenTooltip'

interface Props {
  allowance: Allowance
  selectedStat: ParsedAllowanceStat
  selectedCycle: Cycle
  nextCycle: Cycle | null | undefined
}

const TakenDays = ({ allowance, selectedStat, selectedCycle, nextCycle }: Props) => {
  const stat = selectedStat.toJS()

  const remainingCarryover = stat.carry_over_remaining ?? 0
  const remainingAdjustment = stat.incidences_remaining ?? 0
  const remainingDays = stat.accrued_remaining ?? 0
  const advance = stat.taken_as_advance ?? 0

  const title = allowance.isDays
    ? i18n.t('time_off.taken_tooltip.taken_days')
    : i18n.t('time_off.taken_tooltip.taken_hours')

  return (
    <StatsRow
      title={title}
      amount={stat.used_days}
      isHourlyFixedBalance={isHourlyFixedBalanceAllowance(allowance)}
      tooltip={
        <TakenTooltip
          allowance={allowance}
          selectedStat={selectedStat}
          remainingCarryover={remainingCarryover}
          remainingAdjustment={remainingAdjustment}
          remainingDays={remainingDays}
          usedDays={advance}
          selectedCycle={selectedCycle}
          nextCycle={nextCycle}
        />
      }
    />
  )
}

export default TakenDays
